import Styles from './ArtisticFilter.module.scss'
import cx from 'classnames'
import { startCase } from 'lodash'
import { useFocusRing } from '@react-aria/focus'
import React, { useEffect, useState } from 'react'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { AdvancedImage, placeholder } from '@cloudinary/react'
import { artisticFilter } from '@cloudinary/url-gen/actions/effect'
import { ArtisticFilterType } from '@cloudinary/url-gen/types/types'
import { Skeleton } from 'antd'
import { CloudinaryImage } from '@cloudinary/url-gen'
import { thumbnail } from '@cloudinary/url-gen/actions/resize'

interface Props {
  url: string
  filter: ArtisticFilterType
  onPress: (image: CloudinaryImage, filter: ArtisticFilterType) => void
  isSelected: boolean
}

export const ArtisticFilter = ({ url, filter, onPress, isSelected }: Props) => {
  const { isFocusVisible, focusProps } = useFocusRing()
  const cloudinary = useCloudinary()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsLoading(true)
  }, [url])

  if (!cloudinary) return null

  const image = cloudinary.image(url.split('?')[0]).setDeliveryType('fetch')
  image.effect(artisticFilter(filter))

  const thumbnailImage = cloudinary
    // @ts-ignore
    .image(image.publicID)
    // @ts-ignore
    .setDeliveryType(image.deliveryType)
    .effect(artisticFilter(filter))
    .resize(thumbnail().width(60).height(60))

  return (
    <div
      onClick={() => onPress(image, filter)}
      className={cx(Styles.container, {
        [Styles.focusVisible]: isFocusVisible,
        [Styles.selected]: isSelected,
        [Styles.loading]: isLoading,
      })}
      tabIndex={0}
      role="button"
      {...focusProps}
      aria-label={startCase(filter)}
      data-testid={`artistic-filter-${filter}`}
    >
      <div className={Styles.preview}>
        <AdvancedImage
          cldImg={thumbnailImage}
          plugins={[placeholder()]}
          onLoad={() => setIsLoading(false)}
          className={Styles.image}
        />
        <Skeleton active paragraph={false} className={Styles.skeleton} />
      </div>
    </div>
  )
}
